import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialog } from '../confirmation/confirm.dialog';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard implements CanDeactivate<HasUnsavedChanges> {
  confirmModalRef: MatDialogRef<ConfirmDialog>;

  constructor(
    private readonly dialog: MatDialog,)
  { }

  static readonly DialogWidth = "400px";
  static readonly ConfirmDialogData = {
    id: 1,
    title: "Osparade ändringar",
    text: "Du har osparade ändringar, om du fortsätter kommer dessa att gå förlorade. <br/><br/> Vill du fortsätta?"
  };


  async canDeactivate(component: HasUnsavedChanges): Promise<boolean> {
    if (component.hasUnsavedChanges()) {
      this.confirmModalRef = this.dialog.open(ConfirmDialog, {
        disableClose: false,
        width: UnsavedChangesGuard.DialogWidth,
        autoFocus: false,
        closeOnNavigation: false,
        data: UnsavedChangesGuard.ConfirmDialogData
      });

      return this.confirmModalRef.afterClosed()
        .toPromise()
        .then(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      });
    }
    else {
      return true;
    }
  }
}
